"use client";

import * as m from "motion/react-m";
import { clsx } from "clsx";

export function OmniboxSimpleWrapper({
  children,
  initiallyVisible,
  ...props
}: React.ComponentPropsWithRef<"div"> & { initiallyVisible?: boolean }) {
  return (
    <div {...props} className={clsx("omnibox-wrapper relative flex", props.className)}>
      <m.div
        layoutId='backdrop'
        layoutCrossfade={false}
        className='absolute inset-0 z-1 bg-default'
        transition={{ layout: { duration: 0.4, ease: [0.7, 0, 0.3, 1] } }}
        style={{ borderRadius: 24 }}
      />
      <m.div
        className='relative z-2 w-full'
        initial={{ opacity: initiallyVisible ? 1 : 0 }}
        animate={{ opacity: 1, transition: { delay: 0.2 } }}
        exit={{ opacity: 0 }}
      >
        {children}
      </m.div>
    </div>
  );
}
